export var Width=/*#__PURE__*/function(a){return a.BLOCK="block",a.AUTO="auto",a}({});